import React, { useState, useEffect } from "react";
import "../Diagnostic/PackageDetail.css";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import EastOutlinedIcon from "@mui/icons-material/EastOutlined";
import IcuHomeImg from "../assets/images/IcuHomeImg.avif";
import Person3OutlinedIcon from "@mui/icons-material/Person3Outlined";
import HotelOutlinedIcon from "@mui/icons-material/HotelOutlined";
import { fetchUserAppAPI } from "../utils/api";
import AddAddressModal from "../components/AddAddressModal";
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";

import Doctr from "../assets/images/doctor2.png";

import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";

export default function DoctorAppointment() {
  const navigate = useNavigate();

  const [patientName, setPatientName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [visitDate, setVisitDate] = useState("");
  const [visitTime, setVisitTime] = useState("");

  // Address states
  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState("work");
  const [showAddressModal, setShowAddressModal] = useState(false);

  // Notification Toast
  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success",
  });

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "success" });
    }, 3500);
  };

  const fetchUserAddresses = async (userId) => {
    try {
      const response = await fetchUserAppAPI("list-address", {
        method: "POST",
        body: JSON.stringify({ user_id: userId }),
      });
      if (
        response &&
        response.status === 200 &&
        Array.isArray(response.result)
      ) {
        setAddresses(response.result);

        const savedSel = localStorage.getItem("selectedAddress");
        let activeAddr = null;
        if (savedSel) {
          try {
            const parsedSel = JSON.parse(savedSel);
            activeAddr = response.result.find(
              (a) => a.address_id === parsedSel.address_id,
            );
          } catch (e) {}
        }
        if (!activeAddr && response.result.length > 0) {
          activeAddr =
            response.result.find((a) => a.address_default == 1) ||
            response.result[0];
        }

        if (activeAddr) {
          setSelectedAddressId(activeAddr.address_id);
        }
      }
    } catch (err) {
      console.error("Error fetching user addresses:", err);
    }
  };

  useEffect(() => {
    // 1. Prefill logged in user info
    const userStr = localStorage.getItem("user");
    if (userStr) {
      try {
        const parsed = JSON.parse(userStr);
        const fullName =
          `${parsed.user_first_name || ""} ${parsed.user_last_name || ""}`.trim();
        setPatientName(fullName);
        setPhone(parsed.user_mobile || "");
        setEmail(parsed.user_email || "");
        if (parsed.user_id) {
          fetchUserAddresses(parsed.user_id);
        }
      } catch (e) {
        console.error("Failed to parse user", e);
      }
    }

    const onAddressChange = () => {
      const userStr = localStorage.getItem("user");
      if (userStr) {
        try {
          const parsed = JSON.parse(userStr);
          fetchUserAddresses(parsed.user_id);
        } catch (e) {}
      }
    };

    window.addEventListener("addressChanged", onAddressChange);
    return () => {
      window.removeEventListener("addressChanged", onAddressChange);
    };
  }, []);

  const handleAddAddressSuccess = (newAddress) => {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      try {
        const parsed = JSON.parse(userStr);
        fetchUserAddresses(parsed.user_id);
      } catch (e) {}
    }
    if (newAddress) {
      setSelectedAddressId(newAddress.address_id);
    }
  };

  const handleSelectLocalAddress = (addr) => {
    if (typeof addr === "object") {
      setSelectedAddressId(addr.address_id);
      localStorage.setItem("selectedAddress", JSON.stringify(addr));
    } else {
      setSelectedAddressId(addr);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!patientName.trim()) {
      showToast("Please enter patient name", "warning");
      return;
    }
    if (!phone.trim()) {
      showToast("Please enter phone number", "warning");
      return;
    }
    if (!visitDate) {
      showToast("Please select a visit date", "warning");
      return;
    }
    if (!visitTime) {
      showToast("Please enter visit time", "warning");
      return;
    }

    let addressStr = "";
    if (addresses.length > 0) {
      const found = addresses.find((a) => a.address_id === selectedAddressId);
      if (found) {
        addressStr =
          `${found.address_plot_no || ""} ${found.address_area || ""} ${found.address_city || ""} ${found.address_pincode || ""}`.trim();
      }
    }

    if (!addressStr) {
      if (selectedAddressId === "work") {
        addressStr =
          "15 Corner, Sector 10 Shopping Center Vijay Path Crossing, Madhyam Marg, Mansarovar, Jaipur, Rajasthan 302020";
      } else if (selectedAddressId === "home") {
        addressStr = "45 Shyam Nagar Sodala, Jaipur, Rajasthan 302020";
      } else if (selectedAddressId === "other") {
        addressStr = "80 Ram 200 Feet Road, Jaipur, Rajasthan 302020";
      } else {
        addressStr = "Jaipur, Rajasthan";
      }
    }

    const bookingDetails = {
      patientName,
      phone,
      email,
      visitDate,
      visitTime,
      address: addressStr,
      visitCharge: 500,
      gst: 25,
      totalAmount: 525,
    };

    localStorage.setItem("icuBookingDetails", JSON.stringify(bookingDetails));
    showToast(
      "ICU Booking Details saved! Redirecting to Checkout...",
      "success",
    );
    setTimeout(() => {
      navigate("/icucheckout");
    }, 800);
  };

  return (
    <>
      <Header />

      {/* Toast Notification */}
      {toast.show && (
        <div
          className={`alert alert-${toast.type === "warning" ? "warning" : toast.type === "danger" ? "danger" : "success"} position-fixed top-0 end-0 m-4 shadow-lg`}
          style={{ zIndex: 9999, borderRadius: "10px", minWidth: "300px" }}
        >
          {toast.message}
        </div>
      )}

      <AddAddressModal
        show={showAddressModal}
        onClose={() => setShowAddressModal(false)}
        onSuccess={handleAddAddressSuccess}
      />

      <div className="test_bredcum_sec">
        <div className="container-fluid">
          <div className="test_bredcum">
            <Link to="/">Home</Link>
            <span>&gt;</span>
            <Link to="/">Doctor</Link>
            <span>&gt;</span>
            <span className="name_p">Dr. Gaurav</span>
          </div>
        </div>
      </div>
      <div className="booking_form_main">
        <div className="container-fluid">
          <div className="inner_booking_form">
            <div className="row">
              {/* <div className="col-md-5">
                <div
                  className="icu-booking-left"
                  style={{
                    backgroundImage: `url(${IcuHomeImg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <div className="icu-booking-left-content">
                    <h3>
                      <span>Hospital-grade ICU care,</span> delivered to your
                      door.
                    </h3>
                    <p>
                      Certified nurses, full monitoring setup and doctor-on-call
                      support — all within your home.
                    </p>
                    <div className="icu-feature-left">
                      <div className="feature-left">
                        <Person3OutlinedIcon />
                        <p>
                          Trained Medical <span>Professionals</span>
                        </p>
                      </div>
                      <div className="feature-left">
                        <HotelOutlinedIcon />
                        <p>
                          Complete ICU <span>Equipment Setup</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="col-lg-7">
                <div className="card doc booking_box">
                  <div className="av">
                    <img src={Doctr} alt="" className="img-fluid" />
                  </div>
                  <div className="dinfo">
                    <h1>Dr. Gaurav</h1>
                    <div className="sp">Cardiologists</div>
                    <div className="chips">
                      <span className="chip">
                        <WorkspacePremiumOutlinedIcon />5 years experience
                      </span>
                      <span className="chip">
                        <SchoolOutlinedIcon />
                        MBBS
                      </span>
                      <span className="chip">
                        <LanguageOutlinedIcon />
                        English, Hindi
                      </span>
                      <span className="chip">
                        <LocationOnOutlinedIcon />
                        Jaipur, Rajasthan
                      </span>
                    </div>
                  </div>
                </div>
                <div className="doctor-appointment-main">
                  <div className="form_patient_info">
                    <form onSubmit={handleSubmit}>
                      <div className="booking_box booking_first_sec">
                        <div class="plan-heading">
                          <h2 class="care_se_heading">
                            <span class="count">1</span> Who are you booking
                            For?
                          </h2>
                          <p>Booking for?</p>
                        </div>
                        <div className="radio_btn_booking_form">
                          <input
                            type="radio"
                            id="self"
                            name="booking"
                            defaultChecked
                            hidden
                          />
                          <label htmlFor="self" className="booking_card">
                            <div className="radio_circle"></div>
                            <div className="icon-bookform">
                              <PersonIcon />
                            </div>
                            <h3>Booking For Self</h3>
                          </label>

                          <input
                            type="radio"
                            id="other"
                            name="booking"
                            hidden
                          />
                          <label htmlFor="other" className="booking_card">
                            <div className="radio_circle"></div>
                            <div className="icon-bookform">
                              <GroupsIcon />
                            </div>
                            <h3>Booking for Others</h3>
                          </label>
                        </div>
                      </div>

                      <div className=" booking_box">
                        <div className="row g-3">
                          <div class="plan-heading">
                            <h2 class="care_se_heading">
                              <span class="count">2</span> Patient details
                            </h2>
                            <p>Who is this appointment for?</p>
                          </div>
                          <div className="col-12">
                            <div className="patient-inputs">
                              <label>Patient Name</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Patient Name"
                                value={patientName}
                                onChange={(e) => setPatientName(e.target.value)}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="patient-inputs">
                              <label>DOB</label>
                              <input
                                type="date"
                                className="form-control"
                                placeholder="DOB"
                                required
                              />
                            </div>
                          </div>

                          <div className="col-md-6 col-12">
                            <div className="patient-inputs">
                              <label>Gender</label>
                              <select className="form-select">
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="patient-inputs">
                              <label>Phone Number</label>
                              <input
                                type="tel"
                                className="form-control"
                                placeholder="Phone Number"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                required
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="patient-inputs">
                              <label>Email (optional)</label>
                              <input
                                type="email"
                                className="form-control"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="problem-box">
                              <label htmlFor="">What is the problem?</label>
                              <div className="problem-box-outer">
                                <div class="form-field">
                                  <input
                                    type="checkbox"
                                    id="checkLabel"
                                    class="check"
                                  />
                                  <label for="checkLabel">Fever</label>
                                </div>
                                <div class="form-field">
                                  <input
                                    type="checkbox"
                                    id="checkLabel1"
                                    class="check"
                                  />
                                  <label for="checkLabel1">Cold & cough</label>
                                </div>
                                <div class="form-field">
                                  <input
                                    type="checkbox"
                                    id="checkLabel2"
                                    class="check"
                                  />
                                  <label for="checkLabel2">
                                    Diabetes check
                                  </label>
                                </div>
                                <div class="form-field">
                                  <input
                                    type="checkbox"
                                    id="checkLabel3"
                                    class="check"
                                  />
                                  <label for="checkLabel3">Body pain</label>
                                </div>
                                <div class="form-field">
                                  <input
                                    type="checkbox"
                                    id="checkLabel4"
                                    class="check"
                                  />
                                  <label for="checkLabel4">Skin problem</label>
                                </div>
                                <div class="form-field">
                                  <input
                                    type="checkbox"
                                    id="checkLabel5"
                                    class="check"
                                  />
                                  <label for="checkLabel5">BP check</label>
                                </div>
                                <div class="form-field">
                                  <input
                                    type="checkbox"
                                    id="checkLabel6"
                                    class="check"
                                  />
                                  <label for="checkLabel6">Other</label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <textarea
                              class="inp"
                              placeholder="Describe symptoms or anything the doctor should know (optional)"
                            ></textarea>
                          </div>
                        </div>
                      </div>

                      <div className="sample_address mt-4">
                        <div className="booking_box">
                          <div class="plan-heading">
                            <h2 class="care_se_heading">
                              <span class="count">3</span> Visit address
                            </h2>
                            <p>Where should the doctor come?</p>
                          </div>

                          <div className="samele_add_radio_btn">
                            {addresses.length > 0 ? (
                              addresses.map((addr) => (
                                <label
                                  key={addr.address_id}
                                  className="address_box"
                                >
                                  <input
                                    type="radio"
                                    name="address"
                                    checked={
                                      selectedAddressId === addr.address_id
                                    }
                                    onChange={() =>
                                      handleSelectLocalAddress(addr)
                                    }
                                  />
                                  <span className="radio_circle"></span>
                                  <div className="address_content">
                                    <h4>
                                      {addr.address_title ||
                                        addr.address_type ||
                                        "Saved Address"}
                                    </h4>
                                    <p>
                                      {addr.address_plot_no} {addr.address_area}{" "}
                                      {addr.address_city} {addr.address_pincode}
                                    </p>
                                  </div>
                                </label>
                              ))
                            ) : (
                              <>
                                <label className="address_box">
                                  <input
                                    type="radio"
                                    name="address"
                                    checked={selectedAddressId === "work"}
                                    onChange={() =>
                                      handleSelectLocalAddress("work")
                                    }
                                  />
                                  <span className="radio_circle"></span>
                                  <div className="address_content">
                                    <h4>Work Address</h4>
                                    <p>
                                      15 Corner, Sector 10 Shopping Center Vijay
                                      Path Crossing, Madhyam Marg, Mansarovar,
                                      Jaipur, Rajasthan 302020
                                    </p>
                                  </div>
                                </label>

                                <label className="address_box">
                                  <input
                                    type="radio"
                                    name="address"
                                    checked={selectedAddressId === "home"}
                                    onChange={() =>
                                      handleSelectLocalAddress("home")
                                    }
                                  />
                                  <span className="radio_circle"></span>
                                  <div className="address_content">
                                    <h4>Home Address</h4>
                                    <p>
                                      45 Shyam Nagar Sodala, Jaipur, Rajasthan
                                      302020
                                    </p>
                                  </div>
                                </label>

                                <label className="address_box">
                                  <input
                                    type="radio"
                                    name="address"
                                    checked={selectedAddressId === "other"}
                                    onChange={() =>
                                      handleSelectLocalAddress("other")
                                    }
                                  />
                                  <span className="radio_circle"></span>
                                  <div className="address_content">
                                    <h4>Other Address</h4>
                                    <p>
                                      80 Ram 200 Feet Road, Jaipur, Rajasthan
                                      302020
                                    </p>
                                  </div>
                                </label>
                              </>
                            )}

                            <div className="add_more_btn">
                              <button
                                type="button"
                                onClick={() => {
                                  const userStr = localStorage.getItem("user");
                                  if (!userStr) {
                                    showToast(
                                      "Please login first to add a new address.",
                                      "warning",
                                    );
                                    window.dispatchEvent(
                                      new Event("openLoginModal"),
                                    );
                                  } else {
                                    setShowAddressModal(true);
                                  }
                                }}
                                style={{
                                  background: "none",
                                  border: "none",
                                  color: "#585858",
                                  fontWeight: "600",
                                  cursor: "pointer",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <AddOutlinedIcon /> Add New Address
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div className="col-md-5">
                <div class="care-plan-card appointment-details">
                  <div class="care-plan-header">
                    <div>
                      <h2>Appointment Details Summary</h2>
                      <p>Here's what you've selected</p>
                    </div>

                    <div class="header-icon">
                      <span>★</span>
                    </div>
                  </div>

                  <div class="plan-details">
                    <div class="plan-item">
                      <div class="plan-icon">
                        <VideocamOutlinedIcon />
                      </div>

                      <div class="plan-content">
                        <span class="label">Consultation type</span>
                        <strong>At Home Consult</strong>
                      </div>
                    </div>

                    <div class="plan-item">
                      <div class="plan-icon">
                        <CalendarMonthOutlinedIcon />
                      </div>

                      <div class="plan-content">
                        <span class="label">Date and time</span>
                        <strong>21 October 2026, 11:00 AM</strong>
                      </div>
                    </div>

                    <div class="plan-item">
                      <div class="plan-icon">
                        <PersonOutlinedIcon />
                      </div>

                      <div class="plan-content">
                        <span class="label">Patient</span>
                        <strong>Raj Kumar</strong>
                      </div>
                    </div>

                    <div class="plan-item">
                      <div class="plan-icon">
                        <LocationOnOutlinedIcon />
                      </div>

                      <div class="plan-content">
                        <span class="label">Visit address</span>
                        <strong>Home – 101 Mansarovar 3, Jaipur 302020</strong>
                      </div>
                    </div>
                  </div>

                  <div className="Consultation-fee-outer">
                    <div className="Consultation-fee">
                      <p>Consultation fee</p>
                      <p>₹ 500/-</p>
                    </div>
                    <div className="Consultation-fee total-amount">
                      <p>Total</p>
                      <p>₹ 500/-</p>
                    </div>
                  </div>

                  <div class="form-check term-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkChecked"
                      checked
                    />
                    <label class="form-check-label" for="checkChecked">
                      By Clicking you will be agree to our{" "}
                      <Link to="/terms-and-condition"> Terms & Conditions</Link>{" "}
                      and <Link to="/privacy-policy"> Privacy Policy</Link>
                    </label>
                  </div>

                  <div className="submit_btn_cp">
                    <button type="submit" className="submit_btn_full">
                      <Link
                        to="/thankyou"
                        style={{ color: "#fff", textDecoration: "none" }}
                      >
                        Confirm Booking
                      </Link>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
